import CenteredHeader from "../../Molecules/CenteredHeader/CenteredHeader";
import "./IndustryLightBlueSection.scss";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";


const IndustryLightBlueSection = ({
	checkText,
	yellowText,
	boldText,
	whiteBg,
	withoutHeader,
	noSectionSpace
}) => {
	const {language} = useLanguageCtx();

	return (
		<div
			className={`all-width padding ${
				!noSectionSpace && "top-space-section bottom-space-section"
			}`}
			style={{ backgroundColor: !whiteBg ? "#F0F3F7" : "white" }}
		>
			{!withoutHeader && (
				<div className="mb-40">
					<CenteredHeader
						yellowText={yellowText ? yellowText : content[language].yellow_text}
						boldText={boldText ? boldText : content[language].bold_text}
					/>
				</div>
			)}
			<div className="max-width">
				<div className="industryLightBlueSection-check-text-container all-width">
					{checkText.map((text, index) => (
						<p
							className={`text-width-check white no-space body-16 c-black industryLightBlueSection-column-${text.column}`}
							key={index}
						>
							{text.text}
						</p>
					))}
				</div>
			</div>
		</div>
	);
};

export default IndustryLightBlueSection;
